import { File } from '../file';
import { InternBadge } from '../intern/badge';
import { InternHeadlineRichtext } from '../intern/headline-richtext';
import { InternOverline } from '../intern/overline';

/**
 * Model definition for Opener Content Page
 */
export interface ContentOpenerContentPage {
  __component: 'content.opener-content-page';
  id: string;
  media?: File;
  layout?: 'standard' | 'report';
  overline?: InternOverline;
  headline?: InternHeadlineRichtext;
  text?: string;
  actions?: [];
  badges?: InternBadge[];
}

export function isContentOpenerContentPage(obj: { __component?: string }): obj is ContentOpenerContentPage {
  return obj.__component === 'content.opener-content-page';
}
